import React, { createContext, useContext, ReactNode } from 'react';
import { useGlobalPresence } from '@/hooks/useGlobalPresence';

interface GlobalPresenceContextType {
  onlineUsers: string[];
  isUserOnline: (userId: string) => boolean;
  onlineCount: number;
  isTracking: boolean;
}

const GlobalPresenceContext = createContext<GlobalPresenceContextType | undefined>(undefined);

interface GlobalPresenceProviderProps {
  children: ReactNode;
}

export function GlobalPresenceProvider({ children }: GlobalPresenceProviderProps) {
  const presence = useGlobalPresence();

  return (
    <GlobalPresenceContext.Provider value={presence}>
      {children}
    </GlobalPresenceContext.Provider>
  );
}

export function useGlobalPresenceContext() {
  const context = useContext(GlobalPresenceContext);
  if (context === undefined) {
    throw new Error('useGlobalPresenceContext must be used within a GlobalPresenceProvider');
  }
  return context;
}
